function openKlaviyoForm(event) {
  const formElement = event.target.querySelector('DIV');
  if (!formElement) return;

  const modalId = Math.random();

  const html = `
    <modal id="${modalId}" data-open="false" onclick="closeModal(event)">
      <div onclick="stopPropagation(event)" class="modal-container">
        <button type="button" class="modal-button" onclick="closeModal(event)">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#000" style="width: 24px;height:24px;pointer-events:none;">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
        ${formElement.innerHTML}
      </div>
    </modal>
  `;

  document.body.insertAdjacentHTML('beforeend', html);

  setTimeout(() => {
    const modalElement = document.getElementById(modalId);
    if (modalElement) {
      modalElement.dataset.open = "true";
    }
  }, 50);
  
}

function closeModal(event) {
  let modalElement = event.target;

  if (event.target.nodeName == 'BUTTON') {
    modalElement = findNearestAncestor(event.target, 'MODAL');
  }
  modalElement.dataset.open = "false";
  setTimeout(() => {
    modalElement.remove();
  }, 400);
}

function stopPropagation(event) {
  event.stopPropagation();
  event.preventDefault();
}

function findNearestAncestor(element, tagName) {
  tagName = tagName.toUpperCase();
  while (element) {
    if (element.nodeName === tagName) {
      return element;
    }
    element = element.parentElement;
  }
  return null;
}
